"use client";

import { RoundNotifyMeButton } from "@faire/retailer-visitor-shared/components/RoundNotifyMeButton/index";
import { NotifyMeProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/NotifyMe/NotifyMeProps";
import { NotifyMeWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/styled";
import React, { useCallback, useState } from "react";

export const NotifyMeBackInStockButton: React.FC<NotifyMeProps> = ({
  productOptionToken,
  productToken,
  isSubscribedToBackInStockNotification,
}) => {
  const [isSubscribedToBackInStock, setIsSubsribedToBackInStock] =
    useState<boolean>(isSubscribedToBackInStockNotification);
  const deleteBackInStockNotification = useCallback(
    (optionToken: string) => {
      setIsSubsribedToBackInStock(
        productOptionToken === optionToken ? false : true
      );
    },
    [productOptionToken]
  );
  const preventClickEvents = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <NotifyMeWrapper
      onClick={(e) => preventClickEvents(e)}
      key={`${productToken}-round-notify-me-picker`}
    >
      <RoundNotifyMeButton
        productOptionToken={productOptionToken ?? ""}
        isSubscriedToBackInStock={isSubscribedToBackInStock}
        deleteBackInStockNotification={deleteBackInStockNotification}
      />
    </NotifyMeWrapper>
  );
};
